import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('please_confirm_the_cancellation_of_the_payment'),
    description: defineMessage('the_selected_bill_will__with_this_batch_payment'),
    comment: defineMessage('comment'),
    commentPlaceholder: defineMessage('why_do_you_want_to_cancel_this_payment'),
    confirm: defineMessage('confirm'),
};
